import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=29006619&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"
import style0 from "./consume.vue?vue&type=style&index=0&id=29006619&prod&lang=scss&scoped=true"
import style1 from "./consume.vue?vue&type=style&index=1&id=29006619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29006619",
  null
  
)

export default component.exports